import company1 from "../assets/images/companies/logo_01.webp";
import company2 from "../assets/images/companies/logo_02.webp";
import company3 from "../assets/images/companies/logo_03.webp";
import company4 from "../assets/images/companies/logo_04.webp";
import company5 from "../assets/images/companies/logo_05.webp";
import company6 from "../assets/images/companies/logo_06.webp";

const companies = [
  {
    src: company1,
  },
  {
    src: company2
  },
  {
    src: company3
  },
  {
    src: company4,
  },
  {
    src: company5,
  },
  {
    src: company6,
  },
];

export default companies;
